import {
	SettingsContainer,
	BusinessInfoContainer,
	SecurityContainer,
	AccountManagerContainer,
	InviteFriendsContainer,
	LogoutContainer,
	ContactSupportContainer,
	WithdrawalAccountContainer,
	ManagePayrollContainer,
	InventoryConfigContainer,
	ProductSalesConfigContainer,
	KycContainer,
	AddBusinessContainer,
	FaqsContainer,
	GeneralSettingsContainer,
	CardInfoContainer,
	InvoiceReminderContainer,
	SubscriptionsContainer,
	RenewSubContainer,
	ApiKeysContainer,
} from './SettingsContainer';
import {
	WalletContainer,
	FundWalletContainer,
	TransferContainer,
	SavedBeneficiaryContainer,
	TransferFundOptionContainer,
	NewBeneficiaryContainer,
	TransferFailedContainer,
	TransferSuccessContainer,
	TransferPinConfirmationContainer,
	WithdrawContainer,
	WalletExchangeContainer,
	AccountStatementContainer,
	BankAccountReqContainer,
} from './WalletContainer';
import {
	PayBillsContainer,
	AirtimeContainer,
	BuyAirtimeContainer,
	EnterPinContainer,
	BuyDataContainer,
	CableContainer,
	UtilitiesContainer,
	ElectricBillContainer,
} from './PayBillsContainer';
import {
	InvoiceContainer,
	NewInvoiceContainer,
	NewBulkInvoiceContainer,
	InvoiceSummaryContainer,
	EditInvoiceContainer,
	UpdateInvoiceContainer,
} from './InvoiceContainer';
import {
	ReceiptContainer,
	NewReceiptContainer,
	ReceiptSummaryContainer,
	NewReceiptMultipleContainer,
	EditReceiptContainer,
} from './ReceiptContainer';
import {
	AddCustomerContainer,
	CustomerContainer,
	CreateGroupContainer,
	EditCustomerContainer,
	ViewCustomerContainer,
	DeleteCustomerContainer,
} from './CustomerContainer';
import {
	AddVendorContainer,
	VendorContainer,
	EditVendorContainer,
	ViewVendorContainer,
	DeleteVendorContainer,
} from './VendorContainer';
import {
	OnboardingContainerOne,
	OnboardingContainerTwo,
} from './OnboardingContainer';

import {
	TransactionsContainer,
	RecentTransactionsContainer,
	AddExpensesContainer,
	TransactionQuickLinksCardContainer,
	AddIncomeContainer,
	EditExpenseContainer,
	UpdateDebtContainer,
	EditIncomeContainer,
	UpdateTransactionContainer,
	TagContainer,
} from './TransactionsContainer';

import {
	EmployeesContainer,
	ViewEmployeesContainer,
	AddEmployeesContainer,
	EditEmployeeContainer,
	SpecificEmployeeContainer,
	AddBulkEmployeesContainer,
	TerminateBulkEmployeesContainer,
	ViewGroupsContainer,
	ViewDepartmentsContainer,
	AddLoanContainer,
	UpdateBulkEmployeesSalaryContainer,
	UploadCommissionSheetContainer,
	ApproveCommissionPaymentContainer,
	CommisionTableContainer,
} from './EmployeesContainer';
import {
	PayrollContainer,
	ActionPayrollContainer,
	ViewPayrollContainer,
	PayrollSummaryContainer,
	EmployeePayDetailsContainer,
	BulkAddFundsContainer,
	BulkDeductFundsContainer,
	ReviewPayrollContainer,
	UploadSalesSheetContainer,
	CreatePayrollContainer,
} from './PayrollContainer';
import {
	CheckoutContainer,
	InventoryContainer,
	AddStockContainer,
	OrderPageContainer,
	AddProductContainer,
	DeleteModalContainer,
	EditModalContainer,
	LinkModalContainer,
	SplitViewMoreContainer,
	ViewMoreContainer,
	DeleteProductModalContainer,
	AddVariationMainContainer,
	AddRateCardMainContainer,
	UpdateRateCardMainContainer,
	EditStockContainer,
	ActivityTrailContainer,
	UpdateQtyContainer,
	ViewMoreStockContainer,
	AddBulkProductsContainer,
} from './InventoryContainer';
import {
	EmployeeSalesReportContainer,
	CreateDeductionContainer,
	SaleSheetUploadContainer,
} from './EmployeeSalesReportContainer';
import {
	BusinessAdminContainer,
	AddBusinessAdminContainer,
	PermissionListContainer,
} from './BusinessAdminContainer';
import {
	AdditionalInfoContainer,
	BusinessInsightsContainer,
} from './BusinessInsightsContainer';
import {
	CommissionContainer,
	CreateComTypeContainer,
} from './CommissionContainer';
import {
	SubwalletContainer,
	SubwalletInfoContainer,
} from './SubwalletContainer';
import ForgetPasswordContainer from './ForgetPaswordContainer';
import ResetPasswordContainer from './ResetPasswordContainer';
import AppHomeContainer from './AppHomeContainer';
import NumberVerificationContainer from './AppHomeContainer/NumberVerificationContainer';
import SignUpContainer from './SignUpContainer';
import LoginContainer from './LoginContainer';
import OTPContainer from './OTPContainer';
import {
	ProductDisplayContainer,
	ProductCheckOutContainer,
} from './ProductDisplayContainer';

import {
	BookingContainer,
	DeleteBookingContainer,
	BookingLinkDetailsContainer,
} from './BookingContainer';
import {
	BulkSmsContainer,
	ScheduleMessageContainer,
	NewSmsContainer,
	EditSmsContainer,
} from './BulkSmsContainer';
import {
	MimaCheckoutContainer,
	FxTransferContainer,
} from './CheckoutContainer';
import {
	PaymentLinkContainer,
	DeletePaymentLinkContainer,
	PaymentLinkCheckoutContainer,
} from './PaymentLinkContainer';
import { SplitPaymentsContainer } from './SplitPaymentsContainer';
import { GeneralNotificationContainer } from './GeneralNotificationContainer';
import BusinessReportDLContainer from './AppHomeContainer/BusinessReportDLContainer';
import { BlogLandingContainer, BlogSingleContainer } from './BlogContainer';
import {
	OrdersContainer,
	UpdateOrdersContainer,
	ViewOrdersContainer,
} from './OrdersContainer';
import { TransactionsNewContainer } from './TransactionsNewContainer';
import {
	CatalogueContainer,
	ViewMoreDesignContainer,
	AddRequestContainer,
} from './CatalogueContainer';

export {
	SignUpContainer,
	LoginContainer,
	CreatePayrollContainer,
	CheckoutContainer,
	OTPContainer,
	AddBusinessContainer,
	EmployeeSalesReportContainer,
	ForgetPasswordContainer,
	ResetPasswordContainer,
	OnboardingContainerOne,
	OnboardingContainerTwo,
	AppHomeContainer,
	WithdrawContainer,
	AddStockContainer,
	UpdateBulkEmployeesSalaryContainer,
	EditStockContainer,
	DeleteProductModalContainer,
	ApproveCommissionPaymentContainer,
	TransferPinConfirmationContainer,
	CreateDeductionContainer,
	NewBeneficiaryContainer,
	SavedBeneficiaryContainer,
	WalletContainer,
	UploadSalesSheetContainer,
	FundWalletContainer,
	TransferContainer,
	TransferFailedContainer,
	TransferSuccessContainer,
	TransferFundOptionContainer,
	CustomerContainer,
	AddCustomerContainer,
	EditCustomerContainer,
	ViewCustomerContainer,
	InvoiceContainer,
	NewInvoiceContainer,
	CreateGroupContainer,
	DeleteCustomerContainer,
	InvoiceSummaryContainer,
	AddRateCardMainContainer,
	UpdateRateCardMainContainer,
	PayBillsContainer,
	CableContainer,
	AirtimeContainer,
	BuyAirtimeContainer,
	EnterPinContainer,
	BuyDataContainer,
	UtilitiesContainer,
	SplitViewMoreContainer,
	ElectricBillContainer,
	TransactionsContainer,
	UpdateDebtContainer,
	RecentTransactionsContainer,
	AddExpensesContainer,
	TransactionQuickLinksCardContainer,
	AddIncomeContainer,
	EditInvoiceContainer,
	ReceiptContainer,
	NewReceiptContainer,
	NewReceiptMultipleContainer,
	ReceiptSummaryContainer,
	EditReceiptContainer,
	SettingsContainer,
	BusinessInfoContainer,
	SecurityContainer,
	AccountManagerContainer,
	InviteFriendsContainer,
	LogoutContainer,
	ContactSupportContainer,
	InventoryConfigContainer,
	NewBulkInvoiceContainer,
	BusinessInsightsContainer,
	AdditionalInfoContainer,
	EditExpenseContainer,
	EditIncomeContainer,
	WithdrawalAccountContainer,
	UpdateInvoiceContainer,
	EmployeesContainer,
	ViewEmployeesContainer,
	AddEmployeesContainer,
	EditEmployeeContainer,
	ActionPayrollContainer,
	ViewPayrollContainer,
	PayrollSummaryContainer,
	ManagePayrollContainer,
	EmployeePayDetailsContainer,
	BusinessAdminContainer,
	AddBusinessAdminContainer,
	PermissionListContainer,
	UpdateTransactionContainer,
	PayrollContainer,
	SpecificEmployeeContainer,
	AddBulkEmployeesContainer,
	AddLoanContainer,
	TerminateBulkEmployeesContainer,
	BulkAddFundsContainer,
	BulkDeductFundsContainer,
	ReviewPayrollContainer,
	ViewGroupsContainer,
	ViewDepartmentsContainer,
	SubwalletContainer,
	SubwalletInfoContainer,
	InventoryContainer,
	AddProductContainer,
	OrderPageContainer,
	EditModalContainer,
	DeleteModalContainer,
	LinkModalContainer,
	ViewMoreContainer,
	CommissionContainer,
	CreateComTypeContainer,
	SaleSheetUploadContainer,
	ProductDisplayContainer,
	ProductCheckOutContainer,
	// ProductCheckOutFilledContainer,
	ProductSalesConfigContainer,
	AddVariationMainContainer,
	BulkSmsContainer,
	ScheduleMessageContainer,
	WalletExchangeContainer,
	KycContainer,
	MimaCheckoutContainer,
	PaymentLinkContainer,
	DeletePaymentLinkContainer,
	PaymentLinkCheckoutContainer,
	NewSmsContainer,
	EditSmsContainer,
	SplitPaymentsContainer,
	BookingContainer,
	DeleteBookingContainer,
	BookingLinkDetailsContainer,
	GeneralNotificationContainer,
	AccountStatementContainer,
	BusinessReportDLContainer,
	FaqsContainer,
	GeneralSettingsContainer,
	CardInfoContainer,
	InvoiceReminderContainer,
	AddVendorContainer,
	VendorContainer,
	EditVendorContainer,
	ViewVendorContainer,
	DeleteVendorContainer,
	SubscriptionsContainer,
	RenewSubContainer,
	BlogLandingContainer,
	NumberVerificationContainer,
	UploadCommissionSheetContainer,
	OrdersContainer,
	UpdateOrdersContainer,
	ViewOrdersContainer,
	ActivityTrailContainer,
	UpdateQtyContainer,
	TagContainer,
	ViewMoreStockContainer,
	BankAccountReqContainer,
	BlogSingleContainer,
	TransactionsNewContainer,
	ApiKeysContainer,
	CatalogueContainer,
	ViewMoreDesignContainer,
	AddRequestContainer,
	AddBulkProductsContainer,
	FxTransferContainer,
	CommisionTableContainer,
};
